export default {
  administrator: '#79E3AA',
  account: '#C5F2F2',
  accounts: '#C5F2F2',
  collaborator: '#D8E0FF',
  collaborators: '#D8E0FF',
  contact: '#C2E9FF',
  contacts: '#C2E9FF',
  client: '#1FCBDC',
  clients: '#1FCBDC',
  late: '#ff6461',
  highrisk: '#ff6461',
  highpriority: '#ff6461',
  deleted: '#ff6461',
  mediumrisk: '#ff9057',
  mediumpriority: '#ff9057',
  lowrisk: '#febe6f',
  lowpriority: '#52c175',
  upcoming: '#febe6f',
  pending: '#febe6f',
  edited: '#febe6f',
  today: '#6cb3ff',
  active: '#6cb3ff',
  completed: '#138a5a',
  completedpercent: '#138a5a',
  added: '#4fc696',
  open: '#4fc696',
  started: '#4fc696',
  current: '#6cb3ff',
  due: '#4fc696',
  all: '#b1bac5',
  nopriority: '#b1bac5',
  nodate: '#b1bac5',
  billable: '#6076da',
  nonbillable: '#b1bac5',
  billed: '#138a5a',
  unbilled: '#febe6f',
  inwork: '#6cb3ff',
  read: '#e6ebf1',
  unread: '#3b93f7',
  new: '#3b93f7',
  project: '#3b93f7',
  archived: '#b1bac5',
  closed: '#b1bac5',
  starred: '#febe6f',
  like: '#4ba1ff',
  activity: '#374674',
  activities: '#374674',
  task: '#374674',
  tasks: '#374674',
  todo_items: '#374674',
  tasklist: '#374674',
  tasklists: '#374674',
  time: '#6e1cc6',
  timelog: '#6e1cc6',
  timelogs: '#6e1cc6',
  milestone: '#895ef7',
  milestones: '#895ef7',
  file: '#85bd79',
  fileversion: '#85bd79',
  files: '#85bd79',
  filesversions: '#85bd79',
  attachment: '#85bd79',
  attachments: '#85bd79',
  link: '#ffaf4f',
  links: '#ffaf4f',
  notebook: '#ffa1b8',
  notebooks: '#ffa1b8',
  risk: '#ed581a',
  risks: '#ed581a',
  event: '#1cb986',
  events: '#1cb986',
  calendarevent: '#1cb986',
  calendar: '#1cb986',
  message: '#de5094',
  messages: '#de5094',
  reply: '#de5094',
  billing: '#a981d6',
  comment: '#1e9d4f',
  comments: '#1e9d4f',
  page: '#5a56fa',
  person: '#999',
  board: '#374674',
  info: '#3b93f7',
  healthnone: '#CCCCCC',
  healthgreen: '#8BC34A',
  healthamber: '#FFC107',
  healthred: '#F44336',
  defaultbg: '#ffffff',
  highlightbg: '#ffff9a',
};
